<template>
  <div>
    <div
      v-if="$route.name === 'finStrategy_list_shares' || $route.name === 'finStrategy_list_shares_portfolio' || $route.name === 'finStrategy_list_etfs' || $route.name === 'finStrategy_list_etfs_portfolio'">
      <fin-strategy-list :go-then-to-page="goThenToPage"
                         :mode="mode"
                         :portfolioId="portfolioId"
                         :asset-class-id="assetClassID"
                         :title="mode === 'chooseStrategy' ? 'Strategie auswählen' : 'Alle ' + strategyTypeTitle + '-Strategien'"
      />
    </div>
    <router-view v-else/>
  </div>
</template>

<script>
import FinStrategyList from "@/components/pages/finStrategy/list/StrategyList.vue"

export default {
  name: 'StrategyResult',
  components: {FinStrategyList},
  props: {
    mode: {
      type: String
    },
    assetClassID: {
      type: String
    },
    portfolioId: {
      type: String
    },
    goThenToPage: {
      type: String
    }
  },
  data() {
    return {
      strategyTypeTitle: 'Aktien',
      isShareStrategy: false,
      isEtfStrategy: false,
    }
  },
  mounted() {
    if (this.$route.path.includes('/list/etfs')) {
      this.strategyTypeTitle = 'ETF'
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
